import { Project, Subproject } from '@/app/api';
import ProjectFAQTab from '@/app/components/ProjectFAQTab/ProjectFAQTab';
import ProjectStoryTab from '@/app/components/ProjectStoryTab/ProjectStoryTab';
import SubProjectsDonorsTabs from '@/app/components/SubProjectsDonorsTabs/SubProjectsDonorsTabs';
import { ProjectTabs } from '@/app/pages/ProjectDetail/types';

type SubProjectTabContentProps = {
  project: Project;
  subProject: Subproject;
  activeTabId: ProjectTabs;
};

export const SubProjectTabContent = ({ project, subProject, activeTabId }: SubProjectTabContentProps) => {
  switch (activeTabId) {
    case ProjectTabs.DONORS:
      return <SubProjectsDonorsTabs subProjectId={subProject.id} />;

    case ProjectTabs.FAQS:
      return (
        <ProjectFAQTab
          projectType={project.settings.modeGroup}
          projectId={project.id}
          projectNumericId={project.numericId}
        />
      );

    case ProjectTabs.PROJECT:
    default:
      if (!project.content) {
        return null;
      }

      return (
        <ProjectStoryTab
          projectNumericId={project.numericId}
          startedAt={subProject?.timestamps.createdAt ?? project.timestamps?.startedAt!}
          hasMoreNews={false}
          isSubprojectBannerVisible={false}
          author={subProject?.content.texts.author || undefined}
          texts={[
            {
              label: subProject.content.texts.mainTextLabel ?? undefined,
              htmlContent: subProject.content.texts.mainText ?? undefined,
            },
            {
              label: project.content.texts.mainTextLabel ?? undefined,
              htmlContent: project.content.texts.mainText ?? undefined,
            },
            {
              label: project.content.texts.text1Label ?? undefined,
              htmlContent: project.content.texts.text1 ?? undefined,
            },
            {
              label: project.content.texts.text2Label ?? undefined,
              htmlContent: project.content.texts.text2 ?? undefined,
            },
          ]}
        />
      );
  }
};
